import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ChangeLog,
  ChangeLogFilter,
  ChangeLogFilterAndPagination,
  GymChangeLogResponse,
} from '../model/changelog';

@Injectable({
  providedIn: 'root',
})
export class ChangeLogService {
  constructor(private httpClient: HttpClient) {}

  public getChangeLogs(
    filter: ChangeLogFilterAndPagination
  ): Observable<GymChangeLogResponse> {
    const params = new HttpParams({ fromObject: filter });
    const url = '/upstream/gymfinder/internal/admin/v1/gym-change-log';

    return this.httpClient.get<GymChangeLogResponse>(url, {
      withCredentials: true,
      params,
    });
  }

  public getChangeLogsCount(filter: ChangeLogFilter): Observable<number> {
    const params = new HttpParams({ fromObject: filter });
    const url = '/upstream/gymfinder/internal/admin/v1/gym-change-log/count';

    return this.httpClient.get<number>(url, {
      withCredentials: true,
      params,
    });
  }

  public markAsViewed(changelogId: string): Observable<ChangeLog> {
    const url = `/upstream/gymfinder/internal/admin/v1/gym-change-log/${changelogId}/viewed`;
    return this.httpClient.put<ChangeLog>(url, null, { withCredentials: true });
  }
}
